jQuery(document).ready(function onWhitepaperHomePageReady($) {
    "use strict";

    $('.single-guide .guide-select').on('change', onGuideChange);
    $('.home.page .guide-form form').on('submit', onFormSubmit);

    if($('.single-guide .guide-select').length > 0) {
        var id = $('.single-guide .guide-select[checked]').val();
        $('#guides .guide-form #input_2_4').val(id);
    }

    function onGuideChange() {
        var whitepaper_id = $(this).val();
        $('#guides .guide-form #input_2_4').val(whitepaper_id);
    }

    function onFormSubmit() {
        $('.home.page .guide-form').hide();
        $('.home.page .whitepaper__thanks').show();
        $('.single-guide .guide-select').attr('disabled', 'disabled');
    }
});